import { ISOTimeFloorToQuarterHour } from '@shared/utils/time';
import { parseISO } from 'date-fns';

type Time = string;
type TimeMap<T> = Record<Time, T>;

export const groupByFifteenMinuteIncrement = <
  T extends { time: string; date: string },
>(
  sortedItems: T[],
): TimeMap<T[]> =>
  sortedItems.reduce((acc: TimeMap<T[]>, item: T) => {
    const key = parseISO(
      `${item.date}T${ISOTimeFloorToQuarterHour(item.time)}`,
    ).toISOString();

    if (!acc[key]) acc[key] = [];

    acc[key].push(item);

    return acc;
  }, {});
